import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';

import * as BABYLON from "@babylonjs/core";

import { SceneContext } from './context';
import { KeyboardContext } from './keyboard-context';
import { SocketContext } from './socketio';

import { MetaMaskContext } from '../metamask';
import ConnectButton from '../metamask/button';
import { OwnSodabitsGrid, useOwnSodabits } from '../grid';

import { ChooseSodabitModal } from './modal';

import useJoystick from './gui';
import useNewUserNotification from './newUserNotification';
import Sodabit from './sodabit';
import SkyBox from './skybox';
import Ticker from './ticker';
import MusicPlayer from './music-player';

import './style.scss';
import Header from './Header';
import Footer from '../Footer';


let BASE_PATH = '/island/';
let SODABITS_BASE_PATH = '/sodabits/';


const IslandLand = () => {
  const { sceneRef, setIslandLoaded } = useContext(SceneContext);

  useEffect(() => {
    if (!sceneRef) { return; }
    if (!setIslandLoaded) { return; }
    let scene = sceneRef.current;

    BABYLON.SceneLoader.ImportMesh('', BASE_PATH, 'sodabit-test-land3.obj', scene, (newMeshes) => {
      setIslandLoaded(true);
      let root = newMeshes[0]
        root.scaling = new BABYLON.Vector3(2.5, 2.5, 2.5);
        root.scaling = new BABYLON.Vector3(5, 5, 5);
      //newMeshes = root.getChildMeshes();
      newMeshes.forEach((mesh, idx) => {
        // apply bigger scale to child meshes when using .obj file
        mesh.scaling = new BABYLON.Vector3(5, 5, 5);
        let parent = mesh.parent;
        mesh.setParent(null);
        mesh.physicsImpostor = new BABYLON.PhysicsImpostor(mesh, BABYLON.PhysicsImpostor.MeshImpostor, { mass: 0, friction: 1, restitution: 0.00 }, scene);
        mesh.setParent(parent);
        //mesh.physicsImpostor = new BABYLON.PhysicsImpostor(mesh, BABYLON.PhysicsImpostor.CylinderImpostor, { mass: 0, friction: 1, restitution: 0.00 }, scene);
      })
    });
  }, [ sceneRef, setIslandLoaded ])

  return null;
};

const OtherSodabits = () => {
  const { socket, uid, connected } = useContext(SocketContext);
  const [world, setWorld] = useState({});

  useEffect(() => {
    if (!socket) { return; }

    socket.on('world', setWorld);
  }, [socket, connected]);

  return (
    Object.entries(world)
    .filter(([other_uid, coords]) => {
      return other_uid != uid;
    })
    .map(([other_uid, coords]) => {
      return <Sodabit key={other_uid} { ...coords } />
    })
  );
};

const Loading = () => {
  return (
    <div className="loading text-center mb-5">
      Building Island<Ticker active={true} />
    </div>
  );
};

const IslandApp = () => {
  const { canvasRef, islandLoaded, sceneRef } = useContext(SceneContext);
  const keyboard = useContext(KeyboardContext);
  const [showModal, setShowModal] = useState(false);
  const [sodabit_id, setSodabitId] = useState(false);

  useNewUserNotification(sodabit_id);

  const ownSodabits = useOwnSodabits();
  const haveSodabits = !!ownSodabits.length;
  const haveMoreThanOneSodabit = ownSodabits.length > 1;


  useEffect(() => {
    if (haveSodabits) {
      setSodabitId(ownSodabits[0]);
    }

    if (haveMoreThanOneSodabit) {
      setShowModal(true);
    }
  }, [haveSodabits, haveMoreThanOneSodabit]);

  const selectSodabit = useCallback((sodabit_id) => {
    setSodabitId(sodabit_id);
    setShowModal(false);
  }, []);

  const closeModal = useCallback(() => {
    setShowModal(false);
  }, []);

  useJoystick();


  return (<div id="island">
    <div className="container py-3">
      <Header />
      <main>
        <h1 id="about" className="text-center"> Welcome to Sodabit Island! </h1>
        <blockquote className="text-left text-break lh-lg mb-2">
          <p>
Sodabit Island is a discord channel ONLY for owners of Sodabit NFTS. It is best used on desktop with a mouse so you can
zoom in and out. You can use your keyboard "W,A,S,D" to navigate once you connect your sodabit through metamask. Be sure to log into
discord in order to interact with other Sodabit owners. To purchase a Sodabit, simply visit <a href="https://sodabits.io">sodabits.io</a> and buy one on OpenSea!. Also check our roadmap, we are dropping some more fun for hodlers! Enjoy!
          </p>
          <p className="mt-2">
The discord chat below works best when you have joined our server & verified ownership on <a href="https://discord.io/sodabits">discord.io/sodabits</a>.
          </p>
        </blockquote>

    {
      /*
        <label>
          Sodabit ID
          <input type="number" min="1" value={sodabit_id} onChange={(event) => setSodabitId(event.target.value)} />
        </label>
      */
    }

        <ConnectButton className="align-self-center mb-3 mt-3" label="Sign into Island" />

        { !islandLoaded && <Loading /> }

        <div className="canvas-container">
          { islandLoaded && <MusicPlayer /> }
          <canvas ref={canvasRef} className={islandLoaded ? 'visible':''}> </canvas>
        </div>

        <IslandLand />
        <SkyBox />
        {islandLoaded && sodabit_id && <Sodabit enablePhysics={true} cameraLock={true} sodabit_id={sodabit_id}/>}
        {islandLoaded && <OtherSodabits />}
      </main>
    </div>

    <Footer />
    <ChooseSodabitModal show={showModal} onSelect={selectSodabit} closeModal={closeModal} />
  </div>);

};
export default IslandApp;
